import axios from "axios";
import { Payout_Service } from "../Url";
import { channelLanData } from "../../components/PayoutManagement/helper/payoutdatasample";

export const PayoutLandataAction ={

    GET_PAYOUT_LANDATA_SUCCESS: "GET_PAYOUT_LANDATA_SUCCESS",
    GET_PAYOUT_LANDATA_FAILURE: "GET_PAYOUT_LANDATA_FAILURE",
    GET_PAYOUT_HOLD_REASON_SUCCESS: "GET_PAYOUT_HOLD_REASON_SUCCESS",
    GET_PAYOUT_HOLD_REASON_FAILURE:"GET_PAYOUT_HOLD_REASON_FAILURE",
    GET_PAYOUT_RECOVERY_REASON_SUCCESS:"GET_PAYOUT_RECOVERY_REASON_SUCCESS",
    GET_PAYOUT_RECOVERY_REASON_FAILURE:"GET_PAYOUT_RECOVERY_REASON_FAILURE",
    GET_PAYOUT_HOLD_APPROVAL_SUCCESS: "GET_PAYOUT_HOLD_APPROVAL_SUCCESS",
    GET_PAYOUT_HOLD_APPROVAL_FAILURE: "GET_PAYOUT_HOLD_APPROVAL_FAILURE",
    GET_PAYOUT_LAN_REMARKS_SUCCESS:"GET_PAYOUT_LAN_REMARKS_SUCCESS",
    GET_PAYOUT_LAN_REMARKS_FAILURE:"GET_PAYOUT_LAN_REMARKS_FAILURE",
    GET_PAYOUT_LAN_CHANNELWISE_SUCCESS:"GET_PAYOUT_LAN_CHANNELWISE_SUCCESS",
    GET_PAYOUT_LAN_CHANNELWISE_FAILURE:"GET_PAYOUT_LAN_CHANNELWISE_FAILURE",
    GET_PRINCING_PARTNERDATA_SUCCESS:"GET_PRINCING_PARTNERDATA_SUCCESS",
    GET_PRINCING_PARTNERDATA_FAILURE:"GET_PRINCING_PARTNERDATA_FAILURE",
}


export function payoutLandataAction(props) {
    const { accessToken, tab, reportId, partnerId, page, records  } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                // url: `http://localhost:8301/partner-payout-service/reports/payout-lan-report?lanTab=${tab}&reportId=${reportId}&partnerId=${partnerId}&page=${page}&records=${records}`,
                url: `${Payout_Service}/reports/payout-lan-report?lanTab=${tab}&reportId=${reportId}&partnerId=${partnerId}&page=${page}&records=${records}`,
            });
            const data = response.data;
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_LANDATA_SUCCESS,
                payload: data.data,
            });
            console.log("Payout Landata Data:", data.data);
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_LANDATA_FAILURE,
                payload: error.message || "Failed to fetch payout landata",
            });
            return error;
        }
    };
};


export function getHoldPayoutReasonAction(props) {
    const { accessToken} = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                // url: `http://localhost:8301/partner-payout-service/reports/payout-hold-reason`,
                url: `${Payout_Service}/reports/payout-hold-reason`,
            });
            const data = response.data;
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_HOLD_REASON_SUCCESS,
                payload: data.data
            })
            console.log("Hold Payout Reason Data:", data.data);
            return data.data;
        } catch (error) {
            console.error("Error:", error);
             dispatch({
                type: PayoutLandataAction.GET_PAYOUT_HOLD_REASON_FAILURE,
                payload: error.message || "Failed to fetch payout hold reasons",
            });
            return error;
        }
    };
}

export function getPayoutRecoveryReasonAction(props) {
    const { accessToken, financialYear } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                // url: `http://localhost:8301/partner-payout-service/reports/payout-recovery-option`,
                url: `${Payout_Service}/reports/payout-recovery-option`,
                
            });
            const data = response.data;
            console.log("Payout Recovery Reason Data:", data.data);
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_RECOVERY_REASON_SUCCESS,
                payload: data.data
            })
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_RECOVERY_REASON_FAILURE,
                payload: error.message || "Failed to fetch payout recovery reasons",
            });
            return error;
        }
    };
}

export function getPricingPartnerdata(props){

    const { accessToken} = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "multipart/form-data",
                },
                url: `${Payout_Service}/pricing/partner-pricing/approved`,
            });
            const data = response.data;
            console.log("partner Data:", data.data);
            dispatch({
                type: PayoutLandataAction.GET_PRINCING_PARTNERDATA_SUCCESS,
                payload: data.data
            })
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            dispatch({
                type: PayoutLandataAction.GET_PRINCING_PARTNERDATA_FAILURE,
                payload: error.message || "Failed to fetch partner data",
            });
            return error;
        }
    };
}

export function addReamapRemarkAction(props) {
    const { accessToken, Remapdata } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "multipart/form-data",
                },
                // url: `http://localhost:8301/partner-payout-service/reports/partner-remap-remark`,
                url: `${Payout_Service}/reports/partner-remap-remark`,
                data: Remapdata,
            });
            const data = response.data;
            console.log("Add Remark Data:", data.data);
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            return error;
        }
    };
}


export function addholdRemarkAction(props) {
    const { accessToken, holdData } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                // url: `http://localhost:8301/partner-payout-service/reports/payout-hold-remark`,
                url: `${Payout_Service}/reports/payout-hold-remark`,
                data: holdData,
            });
            const data = response.data;
            console.log("Add Remark Data:", data.data);
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            return error;
        }
    };
}


export function getLanHoldApprovalSuccess(props){
    const {accessToken, payoutId, holdStageId, holdReason, remarksComment, userId,lanNo} = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                // url: `http://localhost:8301/partner-payout-service/reports/payout-recovery-option`,
                url: `${Payout_Service}/reports/update/hold-stage/payout-hold-remark?payoutId=${payoutId}&holdStageId=${holdStageId}&holdReason=${holdReason}&remarks=${remarksComment}&userId=${userId}&lanNo=${lanNo}`,
                
            });
            const data = response.data;
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_HOLD_APPROVAL_SUCCESS,
                payload: data.data
            })
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_HOLD_APPROVAL_FAILURE,
                payload: error.message || "Failed to approve hold",
            });
            return error;
        }
    };
}

export function addRecoveryRemarkAction(props) {
    const { accessToken, recoveryData } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                // url: `http://localhost:8301/partner-payout-service/reports/payout-recovery-remark`,
                url: `${Payout_Service}/reports/payout-recovery-remark`,
                data: recoveryData,
            });
            const data = response.data;
            console.log("Add Recovery Remark Data:", data.data);
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            return error;
        }
    };
}

export function getRemarksLanSuccess(props){
    const {accessToken, payoutId} = props;
    return async (dispatch) => {
        try{
            
            const response = await axios({
                method:"POST",
                headers:{
                   authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*", 
                },
                url: `${Payout_Service}/reports/get/payout-lan-remark?payoutId=${payoutId}`
            });
            const data = response.data;
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_LAN_REMARKS_SUCCESS,
                payload: data.data
            })
            return data.data;
        } catch(error){
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_LAN_REMARKS_FAILURE,
                payload: error.message || "Failed to fetch remarks",
            })
            return error;
        }
    };
}

export function getremaphystorydata(props) {
    const { accessToken, lanNo } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                // url: `http://localhost:8301/partner-payout-service/reports/partner-remap-history?newPartnerId=${partnerId}`,
                url: `${Payout_Service}/reports/partner-remap-history?lanNo=${lanNo}`,
            });
            const data = response.data;
            console.log("Remap History Data:", data.data);
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            return error;
        }
    };
}

export function payoutPartnerLansearch(props){

const { accessToken,  reportId, lanTab, lanNo=null, partnerId, applicantName=null } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",

        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/search/payout-lan-report?lanTab=${lanTab}&reportId=${reportId}&partnerId=${partnerId}&applicantName=${applicantName}&lanNo=${lanNo}`,  
      });
      const data = response.data;
      
      console.log("Payout Partner Data Search:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
    
      return error;
    }
  }

};


export function payoutLandataChanelWiseAction(props) {
    const { accessToken, tab, reportId, partnerId, page, records  } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "POST",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                // url: `http://localhost:8301/partner-payout-service/reports/payout-lan-report?lanTab=${tab}&reportId=${reportId}&partnerId=${partnerId}&page=${page}&records=${records}`,
                url: `${Payout_Service}/reports/payout-channel-lan-report?monthlyReportId=${reportId}&size=${records}&page=${page}`,
            });
            const data = response.data;
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_LAN_CHANNELWISE_SUCCESS,
                payload: data.data,
            });
            console.log("Payout Landata Data:", data.data);
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            dispatch({
                type: PayoutLandataAction.GET_PAYOUT_LAN_CHANNELWISE_FAILURE,
                payload: error.message || "Failed to fetch payout landata",
            });
            return error;
        }
    };
};

export function payoutPartnerChannelWiseLansearch(props){

const { accessToken,  reportId, page, size, searchString } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",

        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/payout-channel-lan-search?monthlyReportId=${reportId}&searchString=${searchString}&page=${page}&size=${size}`,  
      });
      const data = response.data;
      
      console.log("Payout Partner Data Search:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
    
      return error;
    }
  }

};
